import React from 'react';
import {
  List, Datagrid, TextField, EditButton, ShowButton,
  Edit, SimpleForm, TextInput, Create, Show, TabbedShowLayout, Tab,
  ReferenceManyField, DateField
} from 'react-admin';

export const GuestList = props => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="email" />
      <TextField source="phone" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export const GuestShow = props => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Basic Information">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="email" />
        <TextField source="phone" />
        <TextField source="address" />
        <TextField source="nationality" />
        <TextField source="id_document" />
        <TextField source="notes" />
      </Tab>
      <Tab label="Additional Details">
        <TextField source="created_at" />
        <TextField source="updated_at" />
      </Tab>
      <Tab label="Bookings">
        <ReferenceManyField reference="bookings" target="guest_id" label="">
          <Datagrid>
            <TextField source="id" />
            <TextField source="apartment_id" label="Apartment" />
            <DateField source="check_in" />
            <DateField source="check_out" />
            <TextField source="status" />
            <ShowButton />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const GuestEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="name" />
      <TextInput source="email" />
      <TextInput source="phone" />
      <TextInput source="address" />
      <TextInput source="nationality" />
      <TextInput source="id_document" />
      <TextInput source="notes" />
    </SimpleForm>
  </Edit>
);

export const GuestCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="email" />
      <TextInput source="phone" />
      <TextInput source="address" />
      <TextInput source="nationality" />
      <TextInput source="id_document" />
      <TextInput source="notes" />
    </SimpleForm>
  </Create>
);
